var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties from '@wix/ambassador-multilingual-sitetranslator-v2-site-translatable-properties/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Flag;
(function (Flag) {
    Flag["UNDEFINED_FLAG_CODE"] = "UNDEFINED_FLAG_CODE";
    Flag["AFG"] = "AFG";
    Flag["AGO"] = "AGO";
    Flag["AIA"] = "AIA";
    Flag["ALA"] = "ALA";
    Flag["ALB"] = "ALB";
    Flag["AND"] = "AND";
    Flag["ARE"] = "ARE";
    Flag["ARG"] = "ARG";
    Flag["ARM"] = "ARM";
    Flag["ASM"] = "ASM";
    Flag["ATF"] = "ATF";
    Flag["ATG"] = "ATG";
    Flag["AUS"] = "AUS";
    Flag["AUT"] = "AUT";
    Flag["AZE"] = "AZE";
    Flag["BDI"] = "BDI";
    Flag["BEL"] = "BEL";
    Flag["BEN"] = "BEN";
    Flag["BES"] = "BES";
    Flag["BFA"] = "BFA";
    Flag["BGD"] = "BGD";
    Flag["BGR"] = "BGR";
    Flag["BHR"] = "BHR";
    Flag["BHS"] = "BHS";
    Flag["BIH"] = "BIH";
    Flag["BLM"] = "BLM";
    Flag["BLR"] = "BLR";
    Flag["BLZ"] = "BLZ";
    Flag["BMU"] = "BMU";
    Flag["BOL"] = "BOL";
    Flag["BRA"] = "BRA";
    Flag["BRB"] = "BRB";
    Flag["BRN"] = "BRN";
    Flag["BRT"] = "BRT";
    Flag["BTN"] = "BTN";
    Flag["BWA"] = "BWA";
    Flag["CAF"] = "CAF";
    Flag["CAN"] = "CAN";
    Flag["CAT"] = "CAT";
    Flag["CHE"] = "CHE";
    Flag["CHL"] = "CHL";
    Flag["CHN"] = "CHN";
    Flag["CIV"] = "CIV";
    Flag["CMR"] = "CMR";
    Flag["COD"] = "COD";
    Flag["COG"] = "COG";
    Flag["COL"] = "COL";
    Flag["COM"] = "COM";
    Flag["COR"] = "COR";
    Flag["CPV"] = "CPV";
    Flag["CRI"] = "CRI";
    Flag["CUB"] = "CUB";
    Flag["CUW"] = "CUW";
    Flag["CYM"] = "CYM";
    Flag["CZE"] = "CZE";
    Flag["DEU"] = "DEU";
    Flag["DJI"] = "DJI";
    Flag["DMA"] = "DMA";
    Flag["DNK"] = "DNK";
    Flag["DOM"] = "DOM";
    Flag["DZA"] = "DZA";
    Flag["ECU"] = "ECU";
    Flag["EGY"] = "EGY";
    Flag["ERI"] = "ERI";
    Flag["ESP"] = "ESP";
    Flag["EST"] = "EST";
    Flag["ETH"] = "ETH";
    Flag["EUR"] = "EUR";
    Flag["EUS"] = "EUS";
    Flag["FIN"] = "FIN";
    Flag["FJI"] = "FJI";
    Flag["FLK"] = "FLK";
    Flag["FRA"] = "FRA";
    Flag["FRO"] = "FRO";
    Flag["FSM"] = "FSM";
    Flag["GAB"] = "GAB";
    Flag["GBR"] = "GBR";
    Flag["GEO"] = "GEO";
    Flag["GGY"] = "GGY";
    Flag["GHA"] = "GHA";
    Flag["GIB"] = "GIB";
    Flag["GIN"] = "GIN";
    Flag["GLG"] = "GLG";
    Flag["GLO"] = "GLO";
    Flag["GLP"] = "GLP";
    Flag["GMB"] = "GMB";
    Flag["GNB"] = "GNB";
    Flag["GNQ"] = "GNQ";
    Flag["GRC"] = "GRC";
    Flag["GRD"] = "GRD";
    Flag["GRL"] = "GRL";
    Flag["GTM"] = "GTM";
    Flag["GUM"] = "GUM";
    Flag["GUY"] = "GUY";
    Flag["HKG"] = "HKG";
    Flag["HND"] = "HND";
    Flag["HRV"] = "HRV";
    Flag["HTI"] = "HTI";
    Flag["HUN"] = "HUN";
    Flag["IDN"] = "IDN";
    Flag["IMN"] = "IMN";
    Flag["IND"] = "IND";
    Flag["IOT"] = "IOT";
    Flag["IRL"] = "IRL";
    Flag["IRN"] = "IRN";
    Flag["IRQ"] = "IRQ";
    Flag["ISL"] = "ISL";
    Flag["ISR"] = "ISR";
    Flag["ITA"] = "ITA";
    Flag["JAM"] = "JAM";
    Flag["JEY"] = "JEY";
    Flag["JOR"] = "JOR";
    Flag["JPN"] = "JPN";
    Flag["KAZ"] = "KAZ";
    Flag["KEN"] = "KEN";
    Flag["KGZ"] = "KGZ";
    Flag["KHM"] = "KHM";
    Flag["KIR"] = "KIR";
    Flag["KNA"] = "KNA";
    Flag["KOR"] = "KOR";
    Flag["KUR"] = "KUR";
    Flag["KWT"] = "KWT";
    Flag["LAO"] = "LAO";
    Flag["LBN"] = "LBN";
    Flag["LBR"] = "LBR";
    Flag["LBY"] = "LBY";
    Flag["LCA"] = "LCA";
    Flag["LIE"] = "LIE";
    Flag["LKA"] = "LKA";
    Flag["LSO"] = "LSO";
    Flag["LTU"] = "LTU";
    Flag["LUX"] = "LUX";
    Flag["LVA"] = "LVA";
    Flag["MAC"] = "MAC";
    Flag["MAF"] = "MAF";
    Flag["MAR"] = "MAR";
    Flag["MCO"] = "MCO";
    Flag["MDA"] = "MDA";
    Flag["MDG"] = "MDG";
    Flag["MDV"] = "MDV";
    Flag["MEX"] = "MEX";
    Flag["MHL"] = "MHL";
    Flag["MKD"] = "MKD";
    Flag["MLI"] = "MLI";
    Flag["MLT"] = "MLT";
    Flag["MMR"] = "MMR";
    Flag["MNE"] = "MNE";
    Flag["MNG"] = "MNG";
    Flag["MNP"] = "MNP";
    Flag["MOZ"] = "MOZ";
    Flag["MRT"] = "MRT";
    Flag["MSR"] = "MSR";
    Flag["MTQ"] = "MTQ";
    Flag["MWI"] = "MWI";
    Flag["MYS"] = "MYS";
    Flag["MYT"] = "MYT";
    Flag["NAM"] = "NAM";
    Flag["NCL"] = "NCL";
    Flag["NER"] = "NER";
    Flag["NFK"] = "NFK";
    Flag["NGA"] = "NGA";
    Flag["NIC"] = "NIC";
    Flag["NIU"] = "NIU";
    Flag["NLD"] = "NLD";
    Flag["NOR"] = "NOR";
    Flag["NPL"] = "NPL";
    Flag["NRU"] = "NRU";
    Flag["NZL"] = "NZL";
    Flag["OMN"] = "OMN";
    Flag["PAK"] = "PAK";
    Flag["PAN"] = "PAN";
    Flag["PCN"] = "PCN";
    Flag["PER"] = "PER";
    Flag["PHL"] = "PHL";
    Flag["PLW"] = "PLW";
    Flag["PNG"] = "PNG";
    Flag["POL"] = "POL";
    Flag["PRI"] = "PRI";
    Flag["PRK"] = "PRK";
    Flag["PRT"] = "PRT";
    Flag["PRY"] = "PRY";
    Flag["PSE"] = "PSE";
    Flag["PYF"] = "PYF";
    Flag["QAT"] = "QAT";
    Flag["REU"] = "REU";
    Flag["ROU"] = "ROU";
    Flag["RUS"] = "RUS";
    Flag["RWA"] = "RWA";
    Flag["SAU"] = "SAU";
    Flag["SDN"] = "SDN";
    Flag["SEN"] = "SEN";
    Flag["SGP"] = "SGP";
    Flag["SGS"] = "SGS";
    Flag["SHN"] = "SHN";
    Flag["SJM"] = "SJM";
    Flag["SLB"] = "SLB";
    Flag["SLE"] = "SLE";
    Flag["SLV"] = "SLV";
    Flag["SMR"] = "SMR";
    Flag["SOM"] = "SOM";
    Flag["SPM"] = "SPM";
    Flag["SRB"] = "SRB";
    Flag["SSD"] = "SSD";
    Flag["STP"] = "STP";
    Flag["SUR"] = "SUR";
    Flag["SVK"] = "SVK";
    Flag["SVN"] = "SVN";
    Flag["SWE"] = "SWE";
    Flag["SWZ"] = "SWZ";
    Flag["SXM"] = "SXM";
    Flag["SYC"] = "SYC";
    Flag["SYR"] = "SYR";
    Flag["TCA"] = "TCA";
    Flag["TCD"] = "TCD";
    Flag["TGO"] = "TGO";
    Flag["THA"] = "THA";
    Flag["TJK"] = "TJK";
    Flag["TKL"] = "TKL";
    Flag["TKM"] = "TKM";
    Flag["TLS"] = "TLS";
    Flag["TON"] = "TON";
    Flag["TTO"] = "TTO";
    Flag["TUN"] = "TUN";
    Flag["TUR"] = "TUR";
    Flag["TUV"] = "TUV";
    Flag["TWN"] = "TWN";
    Flag["TZA"] = "TZA";
    Flag["UGA"] = "UGA";
    Flag["UKR"] = "UKR";
    Flag["URY"] = "URY";
    Flag["USA"] = "USA";
    Flag["UZB"] = "UZB";
    Flag["VAT"] = "VAT";
    Flag["VCT"] = "VCT";
    Flag["VEN"] = "VEN";
    Flag["VGB"] = "VGB";
    Flag["VIR"] = "VIR";
    Flag["VLC"] = "VLC";
    Flag["VNM"] = "VNM";
    Flag["VUT"] = "VUT";
    Flag["WLF"] = "WLF";
    Flag["WLS"] = "WLS";
    Flag["YEM"] = "YEM";
    Flag["ZAF"] = "ZAF";
    Flag["ZMB"] = "ZMB";
    Flag["ZWE"] = "ZWE";
})(Flag || (Flag = {}));
const _getSiteTranslatablesPropertiesRequest = {};
const _getSiteTranslatablesPropertiesResponse = {};
const _translateSiteRequest = {};
const _translateSiteResponse = {};
/**
 * Start a task to auto-translate all site content that hasn't been translated yet
 * @param mainLanguage - Language from which the site content is translated
 * @public
 * @documentationMaturity preview
 * @requiredField mainLanguage
 * @requiredField options
 * @requiredField options.translatedLanguage
 * @adminMethod
 */
export function translateSite(mainLanguage, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            mainLanguage: '$[0]',
            translatedLanguage: '$[1].translatedLanguage',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _translateSiteRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _translateSiteResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([mainLanguage, options]);
        const reqOpts = ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties.translateSite(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'mainLanguage',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Receive the site's translation status
 * @param mainLanguage - Number of words included in main_language
 * @public
 * @documentationMaturity preview
 * @requiredField mainLanguage
 * @adminMethod
 */
export function getSiteTranslatablesProperties(mainLanguage, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            mainLanguage: '$[0]',
            translatedLanguage: '$[1].translatedLanguage',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSiteTranslatablesPropertiesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSiteTranslatablesPropertiesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['data']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([mainLanguage, options]);
        const reqOpts = ambassadorWixMultilingualSitetranslatorV2SiteTranslatableProperties.getSiteTranslatablesProperties(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'mainLanguage',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=multilingual-sitetranslator-v2-site-translatable-properties.universal.js.map